export const MENU_TYPES = {
  rec: { key: 'rec', value: 'Recreational Menu' },
  med: { key: 'med', value: 'Medical Menu' },
  standard: { key: 'standard', value: 'Standard Menu' },
  viewOnly: { key: 'viewOnly', value: 'View only' },
  multiLocation: { key: 'multiLocation', value: 'Multi-location Selector' },
  dynamicDelivery: { key: 'dynamicDelivery', value: 'Dynamic Delivery' },
};
